export const nhmRouteDef = [ 
    // {
    //     path:'custom_component',
    //     component:AppResourcePermissionComponent
    // }
    
]    